import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class LoginService {
    constructor(private http: HttpClient, private router: Router) {}
    private loginSubject = new Subject();
    private logoutSubject = new Subject();

    loggedIn$ = this.loginSubject.asObservable();
    loggedOut$ = this.logoutSubject.asObservable();

    loggedOut() {
        this.logoutSubject.next({});
    }

    logOut() {
        this.router.navigate(['/Logout']);
    }

    login(username: string, password: string) {
        console.log('Logging in', username);

        let headers = new HttpHeaders();
        headers = headers.append(
            'Authorization',
            'Basic ' + btoa(username + ':' + password)
        );
        headers = headers.append('Content-Type', 'application/json');

        return this.http
            .post(environment.loginURL, null, {
                headers: headers,
                responseType: 'json',
            })
            .pipe(tap(value => this.loginSubject.next(value)));
    }

    resetEmail(username: string) {
        console.log('Reset Email', username);

        let headersV = new HttpHeaders();
        headersV = headersV.append('Content-Type', 'application/json');

        return this.http.put(`${environment.resetURL}/${username}?system=ACL`, {
            headers: headersV,
            responseType: 'json',
        });
    }

    resetMyPassword(password: string) {
        console.log('Reset My Password');

        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');

        return this.http.put(
            `${environment.passwordURL}/${encodeURIComponent(password)}`,
            {
                headers: headers,
                responseType: 'json',
            }
        );
    }
}
